import React from 'react'

import './styles.scss'

function Header() {
  return (
    <header className=''>
      <div className='container'>
        <div className='row'>
          <div className='col-md-8 offset-md-2 col-12 '>
            {/* <h1 className='text-center'>Descarga la aplicación</h1> */}

            <img
              src='/assets/rancagua_digital.png'
              alt='Rancagua Digital'
              className='img-fluid'
            />
          </div>

          {/* <div className='col-12'>
            
          </div> */}
        </div>
      </div>
      <h5 className='box text-center'>
        Aplicación oficial de la Ilustre Municipalidad de Rancagua
      </h5>
    </header>
  )
}

export default Header
